import { useTour } from "@reactour/tour";
import { useEffect } from "react";
import { useHistory } from "react-router";

const WrappedTour: React.FC<any> = (props) => {
  const { currentStep, isOpen } = useTour();
  const history = useHistory();
  useEffect(() => {
    if (isOpen) {
      switch (currentStep) {
        case 0:
          history.push("/artist-ranking");
          break;
        case 1:
          history.push("/artist-profile");
          break;
        case 2:
          history.push("/comparison");
          break;
        case 3:
          history.push("/trends");
          break;
        case 4:
          history.push("/tutorial");
          break;
      }
    }
  }, [currentStep, isOpen, history]);
  const { children } = props;
  return <>{children}</>;
};
export default WrappedTour;
